import { useMediaQuery } from "@react-hook/media-query";

export const useIsSmallScreen = () => {
  const isDesktop = useMediaQuery("only screen and (max-width: 1060px)");
  return isDesktop;
};
